// extracted by mini-css-extract-plugin
export default {"header":"Products_header__kur7n"};